import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurableNavigationMode, WizardComponent as BaseWizardComponent } from 'angular-archwizard';
import { ScreeningUtilityService } from '../../../screening-utility/screening-utility-service';
import { getAllErrors, moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';

export class Question {
  "id": number;
  "radioCheck": String;
  "description": String;
}

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {

  display : boolean = true;
  parentList : any[];
  navigationMode: any;
  questionList : any[];
  alpha : any[];
  requestData : Question[];
  validationForm1: FormGroup;
  validationForm2: FormGroup;
  validationForm3: FormGroup;
  isForm1Submitted: Boolean;
  isForm2Submitted: Boolean;
  isForm3Submitted: Boolean;
  newselectedAttributes2:any=[];
  
  @ViewChild('wizardForm') wizardForm: BaseWizardComponent;
  constructor(private questions: ScreeningUtilityService,private formBuilder : FormBuilder) { }

  ngOnInit(): void {
    this.navigationMode = new ConfigurableNavigationMode("deny", "deny");
    this.formBuilding();

    this.requestData = [];
    this.questions.getMerchantQuestionList("Merchant").subscribe((res:any)=>{
      console.log(res);
      this.questionList = res;
      this.questionList.map((_:any)=>{
         _.isTextField = false;
      })
      // for(let i:number=0;res.length; i++){
      //   this.requestData[i].id = 0;
      //   this.requestData[i].radioCheck = "Empty";
      //   this.requestData[i].description = "Empty";
      // }
      this.alpha = ['a','b','c','d','e','f','g','h'];
    })
  }

  formBuilding(){

    this.validationForm1 = this.formBuilder.group({
      contactName: ['', [Validators.required,moreThanOneWhiteSpaceValidator(), Validators.pattern("[a-zA-Z][a-zA-Z ]+"), Validators.maxLength(200)]],
      contactNumber: ['', [Validators.required]],
      // emailId: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      emailId: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],
      business_category:['',Validators.required],
      business_subCategory:['',Validators.required],
      userType:['',Validators.required],
      parentAgent : ['']

    });

    this.validationForm2 = this.formBuilder.group({
      serviceprovider: ['DECENTRO'],
      authserviceprovider: ['DECENTRO'],
      gstserviceprovider: ['DECENTRO'],
      pancheck: [],
      authPersonPancheck: [],
      pan: ['', [Validators.required]],
      // legalName: ['',[Validators.required, Validators.required,moreThanOneWhiteSpaceValidator(), Validators.maxLength(200),Validators.pattern("^(?!(0))[ 0-9a-zA-Z$&+,:;=?@#|'<>.^*()%!-]+$")]],
      legalName: ['',[Validators.required, Validators.required,moreThanOneWhiteSpaceValidator(), Validators.maxLength(200),Validators.pattern("^[A-Za-z0-9? ,-._)(]+$")]],
      brandName: ['',[Validators.required,moreThanOneWhiteSpaceValidator(), Validators.maxLength(200),Validators.pattern("^[A-Za-z0-9? ,-._)(]+$")]],
      // brandName: ['',[Validators.required,moreThanOneWhiteSpaceValidator(), Validators.maxLength(200),Validators.pattern("^(?!(0))[ 0-9a-zA-Z$&+,:;=?@#|'<>.^*()%!-]+$")]],
      businessType: ['', Validators.required],
      dateOfIncorporation: ['', Validators.required],
     
      authPersonPan: ['', [Validators.required,]],
      authPersonPanName: ['', [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.pattern("[a-zA-Z][a-zA-Z ]+")]],
      address: ['', [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.maxLength, Validators.pattern("^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ,-./!#%^*()@&$]*)?$")]],
      pincode: ['', [Validators.required]],
      city: ['', [Validators.required, Validators.pattern("[a-zA-Z][a-zA-Z ]+"), Validators.maxLength]],
      state: ['', [Validators.required]],
      gstin: ['', [Validators.required]],
      cin:['',[Validators.required]],

     // website:['',[Validators.required,Validators.pattern("^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$")]],
     website:['',[Validators.required,Validators.pattern("^((https?://)|(http://))+(www\.)?[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(/.*)?$")]],
    // emailContactPerson: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],

    //  averageTicket: ['', [Validators.required]],
    //  minimumTicket: ['', [Validators.required]],
    //  maximumTicket: ['', [Validators.required]],
    //  turnOver: ['n', [Validators.required]],
    //  monthlyTurnover: ['', [Validators.required]],
    //  annualTurnover: ['', []],

      isPANVerified: ['N'],
      isCompanyPanVerify: ['N'],
      iIsGSTVerify: ['N'],
      iCompanyPanVerifyName: [''],
      iGSTVerifyName: [''],
      name_as_perpan: [''],
    });

    this.validationForm3 = this.formBuilder.group({
      resellerPartner: ['n', [Validators.required]],
      resellerPartnerId: ['', []],
      giveTestAccess: ['y',],
      pgInstruments: ['', []],
    });

  }

  get form1() {
    return this.validationForm1.controls;
  }

  get form2() {
    return this.validationForm2.controls;
  }

  get form3() {
    return this.validationForm3.controls;
  }

  OnlyNumbersAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58);

  }

  goNext(){
    this.wizardForm.goToNextStep(); 
  }
  enableParentAgent(){
    // console.log("Entity Type :"+this.validationForm1.value.userType);

    // if(this.validationForm1.value.userType == "SubAgent"){
      console.log("SUBAGENT");
      this.display= true;
    // }else{
     console.log("Agent / Merchant");
      this.display= false;
  //  }
  }

  form1Submit(data:any){
    this.isForm1Submitted = true;
    console.log(data)
    this.wizardForm.goToNextStep(); 
  }

  form2Submit(){
    this.wizardForm.goToNextStep(); 
  }

  form3Submit(){
    this.wizardForm.goToNextStep(); 
  }

  form4Submit(){
    this.wizardForm.goToNextStep(); 
  }

  form5Submit(){
    this.wizardForm.goToNextStep(); 
  }

  yesCheckBox(event:any,id:any){
    
    const radioElement = document.querySelector('input[name="nshRadio' + id + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    if(isChecked == true){
      this.questionList[id].isTextField = true;
    }else{
      this.questionList[id].isTextField = false;
    }
    console.log(this.questionList);
  }

  noCheckBox(event:any,id:any){
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    this.questionList[id].isTextField = false;
  }

  yesSubCheckBox(event:any,id:any,subId:any){
    const radioElement = document.querySelector('input[name="nshRadio' + id + '"]:checked') as HTMLInputElement;
    const  relavancy = radioElement ? radioElement.value : null;
    console.log(relavancy);
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    if(isChecked == true){
      this.questionList[id].isTextField = true;
    }else{
      this.questionList[id].isTextField = false;
    }
    console.log(this.questionList);
  }

  noSubCheckBox(event:any,id:any,subId:any){
    const isChecked = (<HTMLInputElement>event.target).checked;
    console.log(isChecked)
    console.log(id);
    console.log(this.questionList);
    this.questionList[id].isTextField = false;
  }

  business_category:any
  business_subCategory:any
  onselectBusinessCat(event:any){
    this.newselectedAttributes2=""
    debugger 
   // this.allFields = { ...this.allFields, ...this.validationForm1.value }
    // this.getBusinessSubCatigory(event?.id||event);  
   // this.getBusinessSubCatigory(event);  
    this.business_category= event?.id||event;
    //this.business_category= event;
   //  this.validationForm1.get('business_category')?.setValue(this.business_category); 
    //this.validationForm1.get('business_category')?.setValue(this.business_category);   
  }
  

}
